module.exports = __webpack_public_path__ + "img/cooperation4.bb3698fd.png";